@if (isImage) {
<a (click)="openPreview()" [matTooltip]="file_name" role="button">
	@if (isChatFile) {
	<img [src]="fileUrl" class="file-thumbnail" />
	}@else {
	<fa-icon [icon]="['fas', getFileExtension()]" class="main-icon"></fa-icon>
	}
</a>
} @else if (isPdf) {
<a (click)="openPreview()" [matTooltip]="file_name" role="button">
	<fa-icon [icon]="['fas', getFileExtension()]" class="main-icon"></fa-icon>
</a>
}@else {
<a href="{{File_Storage_URL}}{{removeDomain()}}" target="_blank" [matTooltip]="file_name">
	<fa-icon [icon]="['fas', getFileExtension()]" class="main-icon"></fa-icon>
</a>
}
<ng-template #modal let-modal>
	<div class="modal-header">
		<h5 class="modal-title">{{file_name}}</h5>
		<button class="btn-close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body">
		@if (isChatFile && isImage) {
		<div class="row align-items-center">
			<div class="col-md-6 text-center">
				<img [src]="fileUrl" class="img-fluid rounded shadow-sm side-preview-img" />
			</div>
			<div class="col-md-6">
				<div class="text-start p-3 border rounded bg-light">
					<div class="mb-2">
						<label class="form-label small fw-bold text-secondary mb-1">Name</label>
						<input type="text" class="form-control form-control-sm" [(ngModel)]="qrNotificationDetails.name"
							placeholder="Enter name">
					</div>
					<div class="mb-2">
						<label class="form-label small fw-bold text-secondary mb-1">Reason</label>
						<input type="text" class="form-control form-control-sm"
							[(ngModel)]="qrNotificationDetails.reason" placeholder="Enter reason">
					</div>
					<div class="mb-3">
						<label class="form-label small fw-bold text-secondary mb-1">Amount</label>
						<input type="number" class="form-control form-control-sm"
							[(ngModel)]="qrNotificationDetails.amount" placeholder="Enter amount">
					</div>
					<div class="mb-0 d-grid">
						<button class="btn btn-sm btn-primary" (click)="sendQRNotification()"
							[disabled]="qrNotificationLoader">
							@if(qrNotificationLoader){
							<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
							}
							Send QR Notification
						</button>
					</div>
				</div>
			</div>
		</div>
		} @else {
		<div class="text-center">
			@if (fileUrl && isImage) {
			<img [src]="fileUrl" class="img-preview" />
			}
			@if (fileUrl && isPdf) {
			<pdf-viewer *ngIf="fileUrl && isPdf" [src]="fileUrl" [render-text]="true" [original-size]="true"
				[show-borders]="true" style="width: 100%;"></pdf-viewer>
			}
		</div>
		}
	</div>
	<div class="modal-footer">
		@if(isReceipt){
		<button class="btn btn-sm btn-primary" (click)="fetchAmount()" [disabled]="fetchingAmount">
			@if(fetchingAmount){
			<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
			}
			Fetch Amount
		</button>
		}
		<button class="btn btn-sm btn-info" (click)="copyLink()">
			Copy File Link
		</button>
		<button class="btn btn-sm btn-secondary" (click)="modal.close()">
			Close
		</button>
	</div>
</ng-template>